import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Space, message, Checkbox } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "./index.scss";
import http from "@/utils/http";
import api from "@/utils/api";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

import loginRight from "@/assets/images/login/login_right.png";
import dImg from "@/assets/images/login/login_d.png";
import dwImg from "@/assets/images/login/login_dw.png";
import heroImg from "@/assets/images/login/login_img.png";
import userIcon from "@/assets/images/login/login_user.png";
import pswIcon from "@/assets/images/login/login_psw.png";

const LoginPage = (props) => {
  const { passwordLoginFn, loading, codeFlag } = props;
  const [form] = Form.useForm();
  const customState = JSON.parse(localStorage.getItem("customState")) || {};
  const initTime = customState.verificationCode || 0;
  const [time, setTime] = useState(initTime);

  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    form.setFieldValue("deviceId", result.visitorId);
  };
  useEffect(() => {
    getDeviceFingerprint();
  }, []);

  useEffect(() => {
    if (time <= 0) return;
    const timer = setInterval(() => {
      setTime((t) => {
        if (t <= 1) {
          clearInterval(timer);
          localStorage.setItem(
            "customState",
            JSON.stringify({ ...customState, verificationCode: 0 })
          );
          return 0;
        }
        localStorage.setItem(
          "customState",
          JSON.stringify({ ...customState, verificationCode: t - 1 })
        );
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [time]);

  const sendFn = async (sec) => {
    setTime(sec);
    const response = await http.post(api.sendVerificationCode, {
      email: form.getFieldValue("email"),
    });
    if (response.code === "1") {
      message.success(response.msg);
    } else {
      message.error(response.msg || "Failed to fetch user data");
    }
  };

  return (
    <>
      <div className="login-page-bg">
        <Row className="login-container">
          <Col span={14} className="left-col">
            <div className="login-left">
              <div className="left-inner">
                <div className="brand">
                  <img className="brand-d" src={dImg} alt="D" />
                  <img className="brand-dw" src={dwImg} alt="DATAworkers" />
                </div>

                <div className="welcome">
                  <div className="welcome-title">Welcome To your workspace</div>
                  <div className="welcome-sub">
                    Secure, simple and efficient
                  </div>
                </div>

                <div className="hero">
                  <img src={heroImg} alt="workspace" />
                </div>
              </div>
            </div>
          </Col>

          <Col span={10} className="right-col">
            <div className="login-right">
              <div className="login-card">
                {/* <div className="login-logo" /> */}

                <div className="form-head">
                  <div className="form-title">Sign in</div>
                  <div className="form-sub">
                    Enter your credentials to continue
                  </div>
                </div>

                <Form
                  form={form}
                  name="normal_login"
                  className="login-form"
                  onFinish={() => passwordLoginFn(form.getFieldValue())}
                  layout="vertical"
                >
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: "Please enter your email." },
                      {
                        min: 4,
                        message: "Email must be at least 4 characters.",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      className="ipt ipt-email"
                      prefix={
                        <img
                          className="prefix-icon"
                          src={userIcon}
                          alt="user"
                        />
                      }
                      placeholder="Enter your email"
                      autoComplete="email"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your password.",
                      },
                      {
                        min: 6,
                        message: "Password must be at least 6 characters.",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      className="ipt ipt-psw"
                      prefix={
                        <img
                          className="prefix-icon"
                          src={pswIcon}
                          alt="password"
                        />
                      }
                      type="password"
                      placeholder="Enter your password"
                      autoComplete="current-password"
                    />
                  </Form.Item>

                  {codeFlag && (
                    <Form.Item
                      name="verificationCode"
                      label="Email Verification Code"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your email verification code.",
                        },
                      ]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Space.Compact style={{ width: "100%", gap: 8 }}>
                        <Input
                          className="ipt"
                          placeholder="Enter your email verification code"
                        />
                        {time > 0 ? (
                          <Button
                            className="btn-secondary"
                            type="primary"
                          >{`${time}s`}</Button>
                        ) : (
                          <Button
                            className="btn-secondary"
                            type="primary"
                            onClick={() => sendFn(59)}
                          >
                            Send
                          </Button>
                        )}
                      </Space.Compact>
                    </Form.Item>
                  )}

                  {/* <Form.Item
                    name="remember"
                    valuePropName="checked"
                    initialValue={true}
                  >
                    <Checkbox className="remember">Remember password</Checkbox>
                  </Form.Item> */}

                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="login-form-button"
                      loading={loading}
                      block
                    >
                      <span>Log In</span>
                      {/* <img src={loginRight} alt="" className="btn-icon" /> */}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LoginPage;
